module.exports = __webpack_public_path__ + "static/media/XED-BNB.6e0c56b5.svg";